import request from './../util/request'
export function queryProjectUsersSellers(data) {
  return request({
    url: '/banniu/getUserAndSellerList/'+data.id,
    method: 'get',
  })
}
export function queryProjectInfo(data) {
  return request({
    url: '/banniu/project/'+data.id,
    method: 'get',
  })
}
export function queryProjectColumn(data) {
  return request({
    url: '/banniu/getColumnList/'+data.id,
    method: 'get',
  })
}
export function queryTask(data) {
  return request({
    url: '/banniu/getTaskById/'+data.id+'/'+data.task,
    method: 'get',
  })
}
export function getOrderInfo(data) {
  return request({
    url: '/v2/tableShare/pub/getOdsInfoByShare/'+data.shareId,
    method: 'post',
    data
  })
}
//任务校验组件值唯一
export function checkOnly(data) {
  return request({
    url: '/v2/project/task/duplicateValue',
    method: 'post',
    data
  })
}

//pdd拼多多插件检测
export function pddPlugInDetection() {
  return request({
    url: '/v2/projects/pagePluginsCheck',
    method: 'get',
  })
}

// 拼多多安全改造
export function pddPlugInSetPddRedis(data) {
  return request({
    url: '/pdd/setParam/setPddRedis',
    method: 'post',
    data
  })
}

//查询关联工单规则信息
export function getTaskRelationRule(data) {
  return request({
    url: `/v2/tableShare/pub/getTaskRelationRule/${data.shareId}`,
    method: 'post',
    data
  });
}

//关联查询工单-全局搜索工单数量/工作表名称
export function getTaskRepeatNumAndNames(data) {
  return request({
    url: `/v2/tableShare/pub/taskRepeatNumAndNames/${data.shareId}`,
    method: 'post',
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/project.js